import { MailOutlined } from '@ant-design/icons';
import { Pagination, Space, Table, Tooltip } from 'antd';
import Column from 'antd/es/table/Column';
import { useSelector } from 'react-redux';
import {
	DeleteActionSvg,
	EditActionSvg,
	SortBottomIcon,
	SortTopIcon,
	TableNextIcon,
	TablePreviousIcon,
} from 'utils/svgs';
import { checkPermission } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';



const CustomTable = ({
	dataSource, handleTableChange, onShowSizeChange, isLoading, search, totalRecords, performSearchHandler, reinviteUserAction, openDrawerHandler, setDrawerInfoHandler, setEditSelectedCompany, showModal, currentPage, pageSize, isSearchCancel, setSearch, setIsSearchCancel }: any) => {


	const userPermissions = useSelector(
		(state: any) => state?.userProfile
	);
	const isEditPermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Company Setup',
		permission: ['edit'],
	});

	const isDeletePermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Company Setup',
		permission: ['delete'],
	});
	const isAddPermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Company Setup',
		permission: ['add'],
	});

	const editDataHandler = (userObject: any) => {
		openDrawerHandler();
		setDrawerInfoHandler('Edit User');
		setEditSelectedCompany(userObject);
	};

	// Delete user data handler
	const deleteDataHandler = (userObject: any) => {
		setEditSelectedCompany(userObject);
		showModal();
	};
	return (
		<>
			<div className={`${styles['body']} user-table`} >
				<SearchAndFilter
					performSearchHandler={performSearchHandler}
					searchValue={search}
					title={'Company List'}
					openDrawerHandler={openDrawerHandler}
					isSearchCancel={isSearchCancel}
					setSearch={setSearch}
					setIsSearchCancel={setIsSearchCancel}
				/>

				<Table
					rowKey={(record: any) => record?.userCompanyRoleId}
					dataSource={dataSource}
					// key={userPermissions}
					pagination={false}
					loading={isLoading}
					onChange={handleTableChange}
					scroll={{ y: 'calc(100vh - 300px)' }}
				>
					<Column
						title={<p style={{ padding: '0 10px' }}>Company Name</p>}
						dataIndex="name"
						key="name"
						className="user-column bg-white"
						width={'15%'}
						sorter
						sortDirections={['ascend', 'descend', 'ascend']}
						render={(value: any) => (value ? value : '-')}
						sortIcon={({ sortOrder }) => {
							const isAscend = sortOrder === 'ascend';
							const isDescend = sortOrder === 'descend';

							return (
								<>
									<SortTopIcon fill={isAscend ? '#949494' : undefined} />
									<SortBottomIcon fill={isDescend ? '#949494' : undefined} />
								</>
							);
						}}
					/>

					<Column
						title="Email"
						dataIndex="email"
						key="email"
						className="bg-white"
						width={'20%'}
						render={(value: any) => (value ? value : '-')}
					/>
					<Column
						title="Address"
						dataIndex="address"
						key="address"
						className="bg-white"
						width={'12%'}
						render={(value: any) => (value ? value : '-')}
					/>

					{(isEditPermission || isDeletePermission) && (
						<Column
							title="Action"
							dataIndex="action"
							key="action"
							className="bg-white"
							width={'15%'}
							render={(value, data: any) => {
								return (
									<Space size={20}>
										{isEditPermission &&
											data.userId !== userPermissions?.data?.id &&
											(!data.isAdmin || userPermissions?.data?.isSuperAdmin) ?
											(<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn"
												onClick={() =>
													editDataHandler(data)
												}
											>
												<EditActionSvg />
											</div>
											) : (
												<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn">

													<EditActionSvg />
												</div>
											)}

										{isDeletePermission &&
											data.userId !== userPermissions?.data?.id &&
											(!data.isAdmin || userPermissions?.data?.isSuperAdmin) ? (
											<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn "
												onClick={() =>
													deleteDataHandler(data)
												}
											>
												<DeleteActionSvg />
											</div>
										) : (
											<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn ">
												<DeleteActionSvg />
											</div>
										)}

										{data.invitationStatus === 'Pending' && isAddPermission && (
											<Tooltip title="Reinvite">
												<div
													className="cursor-pointer flex align-center justify-center rounded-action-btn "
													onClick={() => {
														reinviteUserAction(data);
													}}
												>
													<MailOutlined />
												</div>
											</Tooltip>
										)}
									</Space>
								);
							}}
						/>
					)}
				</Table>

				<div className={styles['pagination__wrapper']}>
					<Pagination
						current={currentPage}
						pageSize={pageSize}
						showSizeChanger
						onChange={onShowSizeChange}
						total={totalRecords}
						itemRender={(page, type, originalElement) => {
							return (
								<div className={styles['pagination']}>
									{type === 'prev' ? (
										<button
											className={`${styles['pagination']} ${styles['pagination__button']}`}
										>
											<TablePreviousIcon />
											<p
												className={
													styles['pagination__previous']
												}
											>
												Previous
											</p>
										</button>
									) : type === 'next' ? (
										<>
											<button
												className={`${styles['pagination']} ${styles['pagination__button']}`}
											>
												<p
													className={
														styles['pagination__next']
													}
												>
													Next
												</p>
												<TableNextIcon />
											</button>
										</>
									) : (
										originalElement
									)}
								</div>
							);
						}}
					/>
				</div>
			</div>
		</>
	);
};

export default CustomTable;
